'use strict';


const tinybind = require('tinybind');
const $ = require('zepto');

const ConfigurationHelper = require('../helpers/configuration');

tinybind.formatters.log = obj => {
	console.log('💁', obj); // eslint-disable-line no-console
};
tinybind.formatters.string = (string, replacements) => {
	return ConfigurationHelper.getString(string, replacements);
};
tinybind.formatters.append = (a, b) => {
	return String(a || '') + String(b || '');
};
tinybind.formatters.prepend = (a, b) => {
	return String(b || '') + String(a || '');
};
tinybind.formatters.fallback = (a, b) => {
	return String(a || '') || String(b || '');
};
tinybind.binders.order = function(el, value) {
	el.style.order = value
}

/**
 * TemplateHelper
 *
 * @class TemplateHelper
 * @author Sebastian Pekarek
 */
class TemplateHelper {

	/**
	 * Renders the given template in the given
	 * view with tinybind.js
	 *
	 * @param {object} options
	 * @param {View} options.view
	 * @param {string} options.template
	 * @param {object} [options.data]
	 */
	static render (options) {
		if (!options.view) {
			throw new Error('TemplateHelper.render: Unable to render: no view given!');
		}
		if (typeof options.template !== 'string') {
			throw new Error('TemplateHelper.render: Unable to render: no template given!');
		}
		
		const data = {
			view: {}
		};
		Object.assign(data, options.data || {});
		
		
		// bind methods of view to template
		const viewFunctions = Object.getPrototypeOf(options.view);
		for (const k of Object.getOwnPropertyNames(viewFunctions)) {
			const f = viewFunctions[k];
			if (typeof f === 'function') {
				data.view[k] = function () {
					return f.apply(options.view, arguments);
				};
			}
		}
		
		// console.log('☁︎ options', options);
		// console.log('☁︎ data', options.data);
		
		options.view.$el = $(options.template);
		$(options.view.parent.$el).append(options.view.$el);
		
		tinybind.bind(options.view.$el.get(0), data);
	}
}

module.exports = TemplateHelper;
